import { render, staticRenderFns } from "./MinorConfig.vue?vue&type=template&id=abec59bc&scoped=true&"
import script from "./MinorConfig.vue?vue&type=script&lang=js&"
export * from "./MinorConfig.vue?vue&type=script&lang=js&"
import style0 from "./MinorConfig.vue?vue&type=style&index=0&id=abec59bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abec59bc",
  null
  
)

export default component.exports